import { render, staticRenderFns } from "./SelectorExamsAutocomplete.vue?vue&type=template&id=991ea7e0&"
import script from "./SelectorExamsAutocomplete.vue?vue&type=script&lang=js&"
export * from "./SelectorExamsAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports